import PageTemplate from './PageTemplate.vue'

export default {
    install (Vue) {
        Vue.mixin({
            created () {
                const templates = { PageTemplate }
                for (const key in templates) {
                    Vue.component(key, templates[key])
                }
            }
        })
    }
}